<template>
  <div>
    <el-card
      header="Key Fields"
      shadow="never"
    >
      <el-col
        :md="12"
        style="text-align: center;"
      >
        <p>
          <b>Name: </b>
          <span>{{ $_.get(profile, 'name') || '-' }}</span>
        </p>
        <p>
          <b>Position: </b>
          <span>{{ $_.get(profile, 'position') || '-' }}</span>
        </p>
        <p>
          <b>Primary Phone: </b>
          <a
            v-if="$_.get(profile, 'phone_primary')"
            :href="`tel:${$_.get(profile, 'phone_primary')}`"
          >{{ $_.get(profile, 'phone_primary') || '-' }}</a>
          <span v-else>-</span>
        </p>
        <p>
          <b>Secondary Phone: </b>
          <a
            v-if="$_.get(profile, 'phone_secondary')"
            :href="`tel:${$_.get(profile, 'phone_secondary')}`"
          >{{ $_.get(profile, 'phone_secondary') || '-' }}</a>
          <span v-else />
        </p>
        <p>
          <b>Email: </b>
          <a
            v-if="$_.get(profile, 'email')"
            :href="`mailto:${$_.get(profile, 'email')}`"
          >{{ $_.get(profile, 'email') || '-' }}</a>
        </p>
      </el-col>
      <el-col
        :md="12"
        style="text-align: center;"
      >
        <b>Teams: </b>
        <ul
          v-for="team in profile.teams"
          :key="team.code"
        >
          <router-link :to="{ name:'manage-accounts-account', params: { accountId: team.account.id } }">
            {{ team.name }} - {{ team.account.name }}
          </router-link>
        </ul>
      </el-col>
    </el-card>
  </div>
</template>

<script>
export default {
  props: {
    profile: {
      type: Object,
      required: true
    }
  }
}
</script>

<style>

</style>
